
// EmployeesList.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getEmployees } from "../features/employees/employeeSlice";
import Employee from "./Employee";
import { Col, Container, Row } from "react-bootstrap";
import { Typography } from "@mui/material";
import Spinner from "../components/Spinner";

const EmployeesList = ({ employees, handleEmployeeClick, isLoginSuccess, isEntrySuccess,}) => {
  const { isLoading } = useSelector((state) => state.employees);
  const dispatch = useDispatch();

  useEffect(() => {
      // console.log('dispatch get employees');
      dispatch(getEmployees());
  }, [dispatch]);
  
  return (
    <Container>
      <div>
        {isLoading ? (
          <Spinner />
        ) : (
            <div>
              <Row className="mg-top text-center"><Typography gutterBottom={true} variant="h4">Our Employees</Typography></Row>
              <Row className="px-0 px-lg-5 d-flex h-100 align-items-center justify-content-center">
                {employees.map(employee =>(
                  <Col xs={12} sm={4} md={4} lg={4} xl={3}key={employee.id}>
                        <div onClick={() => handleEmployeeClick(employee)}>
                        <Employee 
                            key={employee.id} 
                            employee={employee}
                            handleEmployeeClick={handleEmployeeClick}
                        />
                      </div>
                  </Col>
                ))}
              </Row>
            </div>
        )}
      </div>
    </Container>
  );
};

export default EmployeesList;

